<template>
  <div id="app2">
    <transition name="fade-transform" mode="out-in">
    <router-view></router-view>
  </transition>
  </div>
</template>

<script>

export default {
  id:'app2',
  name: 'Layout'
}
</script>
<style scoped>
 #app2{
  width:100%;
  height:100%;
 }
</style>